import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import Table from "@components/Table";
import { Box, Container } from "@mui/material";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useSWRMutation from "swr/mutation";
import ButtonBackPage from "@components/ButtonBackPage";
import BackgroundImageCst from "@components/BackgroundImageCst";
import { ServicesURL } from "@utils/utilsApi";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { useParams } from "react-router-dom";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { useResetFilters } from "@hooks/useFiltersProvider";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";

const LocationsDigited: React.FC = () => {
  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${PagesID["corporate.locations"]}`;

  const [idLocationDeleted, setIdLocationDeleted] = useState<
    string | number | undefined
  >(undefined);
  const { id = "1" } = useParams();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  useResetFilters();

  const { columns, dataTable, actionsTopToolbar, actionForRow, mutate } =
    useFetchTable(
      ServicesURL.sites.replace("{corporateId}", `${id}`),
      PagesID["corporate.locations"],
      filters[filterId],
    );

  const { trigger: triggerDeleteLocation } = useSWRMutation(
    `${ServicesURL.sites.replace(
      "{corporateId}",
      `${id}`,
    )}/${idLocationDeleted}`,
    (url: string) => {
      return fetcher<any>(url, MethodType.DELETE);
    },
  );

  const handleDelete = React.useCallback(async () => {
    if (idLocationDeleted) {
      setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
      try {
        await triggerDeleteLocation();
        const newData = [
          ...dataTable.output.filter((el: any) => el.id !== idLocationDeleted),
        ];
        mutate({ ...dataTable, ...{ output: newData } });
        setOpenToast({ s: StatusEnum.OK, message: "" });
      } catch (error) {
        setOpenToast(undefined);
        setIdLocationDeleted(undefined);
        console.error(error);
      }
    }
  }, [triggerDeleteLocation, idLocationDeleted, mutate, dataTable]);

  const { t } = useTranslation(["locations-page"]);

  return (
    <>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-locations.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <ButtonBackPage />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <Table
            id={PagesID.locations}
            data={(dataTable && dataTable.output) || []}
            columns={columns || []}
            configurationTopToolbar={actionsTopToolbar}
            configurationActionForRow={actionForRow?.map((action: any) => {
              if (action.type === "delete") {
                return {
                  ...action,
                  callBack: (row: any) => setIdLocationDeleted(row),
                };
              }
              return action;
            })}
            totalPages={dataTable?.metadata?.total_elements}
          />
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!idLocationDeleted}
        title={t("delete-item", { ns: "modal" })}
        description={t("confirm-delete", { ns: "modal" })}
        routeToSamePage={true}
        onCallBackClosed={() => {
          setOpenToast(undefined);
          setIdLocationDeleted(undefined);
        }}
        onActionConfirmed={() => handleDelete()}
        status={openToast}
      />
    </>
  );
};

export default LocationsDigited;
